import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

export function getWaStatus(statusSession) {
  const raw = statusSession;
  const s = String(raw || '');
  if (['CONNECTED', 'connected'].includes(s)) {
    return { code: 'connected', label: 'Connected', color: '#16a34a', Icon: CheckCircle2 };
  }
  if (['pending', 'scanning', 'pairing'].includes(s)) {
    return { code: 'connecting', label: 'Connecting', color: '#d97706', Icon: AlertTriangle };
  }
  if (['ERROR', 'error', 'DISCONNECTED', 'disconnected', 'offline', 'qr_required', 'QR_REQUIRED', 'qr_generated'].includes(s) || !s) {
    return { code: 'disconnected', label: 'Disconnected', color: '#dc2626', Icon: XCircle };
  }
  if (['SUPERKOS', 'superkos', 'issuperkos', 'using_superkos'].includes(s)) {
    return { code: 'superkos', label: 'Account Superkos', color: '#eab308', Icon: AlertTriangle };
  }
  return { code: 'unknown', label: raw || 'Unknown', color: '#6b7280', Icon: AlertTriangle };
}